
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-ba90fe00&scoped=true!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./for-you.vue")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./for-you.vue"),
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-ba90fe00!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./for-you.vue"),
  /* scopeId */
  "data-v-ba90fe00",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/external/for-you.vue
// module id = 1999
// module chunks = 1